import { FilmTile } from "@features/atoms/FilmTile"
import { Appear } from "@features/motion/Appear"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Program Header",
}

export default defineBlock("programs/program-header", (props) => {
  return (
    <>
      <div className="program-header content-sized block-spacing flex flex-col gap-10 items-center text-blue">
        <Appear className="w-full flex flex-col gap-4 items-center justify-center">
          <p className="type-label-s text-center text-blue">Program</p>
          <h1 className="type-title-xl text-center text-blue">
            {env.admin ? (
              <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" />
            ) : (
              <>{props.program?.title}</>
            )}
          </h1>
        </Appear>

        <div className="w-full md:w-narrowContentW mx-auto flex flex-col gap-5 items-start justify-center [&_.presented-by]:mt-6 [&_p]:!my-0">
          {!!props.program?.programData?.shortDescription && (
            <div
              className="rich-text-group !type-body-l"
              dangerouslySetInnerHTML={{ __html: props.program?.programData?.shortDescription }}
            />
          )}
          {!!props.program?.programData?.longDescription && (
            <div
              className="rich-text-group !type-body-m"
              dangerouslySetInnerHTML={{ __html: props.program?.programData?.longDescription }}
            />
          )}
          <InnerBlocks
            allowedBlocks={["#inline"]}
            defaultBlocks={[["core/paragraph", {}]]}
            adminClassName="w-full flex flex-col gap-5"
          />
        </div>
      </div>
    </>
  )
})
